import { createFileRoute } from "@tanstack/react-router";
import { LegacyLinkRedirect } from "@/components/signin/legacy-link";

/**
 * `/callback?token=…` — ссылка подтверждения почты СТАРОГО SSO.
 *
 * Экрана под этим адресом у нас нет и быть не должно: почту мы подтверждаем
 * кодом из письма, а не ссылкой. Но письма старого SSO живут семь суток, и на
 * Э5 они приедут сюда — встречать их «Not Found» роутера нельзя.
 */
export const Route = createFileRoute("/callback")({
	component: LegacyLinkRedirect,
});
